<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <!-- Imagen lateral -->
    <template #right>
      <div
        class="relative h-full flex items-center justify-center"
        style="
          width: 45vw;
          background-image: url('/assets/img/fondo-login.png');
          background-size: cover;
          background-position: center;
        "
      >
        <div class="absolute inset-0">
          <!-- Overlay -->
          <div class="absolute inset-0 bg-gradient-to-b from-[#0b3b8c] via-[#03142f] to-black opacity-80"></div>
          <!-- Logo -->
          <div class="relative h-full flex items-center justify-center">
            <div class="auth-side-logo">
              <img src="/logo_azul.png" alt="SpendFit" class="auth-side-logo__image" />
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Formulario -->
    <template #content>
      <main class="h-screen w-full flex flex-col">
        <div class="flex-1 flex items-center justify-center overflow-y-auto">
          <div class="mx-auto w-full max-w-[600px] py-10 px-6">
            <div class="app-form w-full">
              <RouterView />
            </div>
          </div>
        </div>

        <footer class="pb-6 px-6 text-center text-xs leading-5 text-gray-500">
          <p>Este sitio está protegido por reCAPTCHA.</p>
          <p>
            Se aplican la
            <a href="https://policies.google.com/privacy" target="_blank" class="text-primary hover:underline">
              Política de privacidad
            </a>
            y los
            <a href="https://policies.google.com/terms" target="_blank" class="text-primary hover:underline">
              Términos de servicio
            </a>
            de Google.
          </p>
        </footer>
      </main>
    </template>
  </VaLayout>

  <!-- Versión móvil -->
  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="auth-logo">
        <img src="/logo_horizontal_blanco.png" alt="SpendFit" class="auth-logo__image" />
      </div>
      <div class="auth-mobile-scroll h-full overflow-y-auto">
        <main class="mx-auto max-w-[420px]">
          <div class="flex flex-col items-start w-full">
            <div class="app-form w-full">
              <RouterView />
            </div>
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'

const breakpoint = useBreakpoint()
</script>

<style lang="scss" scoped>
.auth-logo {
  position: fixed;
  top: 1.25rem;
  left: 50%;
  z-index: 20;
  width: min(220px, 64vw);
  aspect-ratio: 1229 / 348;
  overflow: hidden;
  background: var(--va-primary);
  transform: translateX(-50%);
}

.auth-logo__image {
  position: absolute;
  display: block;
  max-width: none;
  width: 124.98%;
  height: 294.25%;
  left: -13.75%;
  top: -90.52%;
}

.auth-side-logo {
  position: relative;
  width: min(18rem, 70%);
  aspect-ratio: 1281 / 406;
  overflow: hidden;
}

.auth-side-logo__image {
  position: absolute;
  display: block;
  max-width: none;
  width: 119.91%;
  height: 252.22%;
  left: -10.85%;
  top: -68.23%;
}

.auth-mobile-scroll {
  padding: calc(1.25rem + min(220px, 64vw) * 348 / 1229 + 2.25rem) 1rem 1rem;
}
</style>
